import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Share2 } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-secondary text-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-primary text-secondary rounded-lg p-2">
                <span className="text-xl font-bold">🎭</span>
              </div>
              <h3 className="text-xl font-bold">Uni9ja Hub</h3>
            </div>
            <p className="text-surface/70 text-sm">
              Connect, compete, and collaborate with students across Nigeria.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/feed" className="text-surface/70 hover:text-primary transition">Feed</Link></li>
              <li><Link to="/contests" className="text-surface/70 hover:text-primary transition">Contests</Link></li>
              <li><Link to="/quiz" className="text-surface/70 hover:text-primary transition">Quiz Arena</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-surface/70 hover:text-primary transition">About Us</a></li>
              <li><a href="#" className="text-surface/70 hover:text-primary transition">Privacy Policy</a></li>
              <li><a href="#" className="text-surface/70 hover:text-primary transition">Terms of Service</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Mail size={18} className="text-primary" />
                <a href="mailto:info@uni9ja.com" className="text-surface/70 hover:text-primary transition text-sm">info@uni9ja.com</a>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={18} className="text-primary" />
                <a href="tel:+2349012345678" className="text-surface/70 hover:text-primary transition text-sm">+234 901 234 5678</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={18} className="text-primary" />
                <span className="text-surface/70 text-sm">Lagos, Nigeria</span>
              </div>
            </div>
          </div>
        </div>

        {/* Social Links - using generic Share2 icons */}
        <div className="border-t border-surface/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-surface/70 text-sm">&copy; 2024 Uni9ja Media Hub. All rights reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="bg-primary/20 hover:bg-primary text-primary hover:text-secondary p-3 rounded-lg transition">
              <Share2 size={18} />
            </a>
            <a href="#" className="bg-primary/20 hover:bg-primary text-primary hover:text-secondary p-3 rounded-lg transition">
              <Share2 size={18} />
            </a>
            <a href="#" className="bg-primary/20 hover:bg-primary text-primary hover:text-secondary p-3 rounded-lg transition">
              <Share2 size={18} />
            </a>
            <a href="#" className="bg-primary/20 hover:bg-primary text-primary hover:text-secondary p-3 rounded-lg transition">
              <Share2 size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;